import React, { ReactNode } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as R from 'ramda';
import { Trans, useTranslation } from 'react-i18next';
import { Popup } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import AsyncList from '../../../../common/components/list/async';
import ProfileImage from '@common/components/profile-image';
import Profile from '../../../../common/components/profile';
import Modal from '../../../../common/components/modal';
import fetchMembersAction from '../../actions/fetch-members';
import { ETimelineTypes } from '../../definitions';
import * as usersSelector from '../../../core/selectors/users';
import { PopoverContent } from '../../../../common/components/profile/popover';
import LinkWrapper from '@common/components/linkWrapper';

const getRowProps = (item: unknown, index: number) => ({
  size: 32,
  user: item,
  // enablePopover: true,
  isFirst: index === 0,
});

type OwnProps = {
  channel: typeof ETimelineTypes;
  onEnter?: () => unknown;
};

const mapDispatchToProps = {
  fetchMembers: fetchMembersAction,
};

const connector = connect(undefined, mapDispatchToProps);

type Props = OwnProps & ConnectedProps<typeof connector>;

// here we are using semantic ui's Popover because this popover
// source\shared\common\components\profile\popover.js
// relies on bootstrap's Overlay which is buggy
function MemberProfileImage(props: any) {
  const className = 'pointer';
  return (
    <Popup
      className="popover ProfilePopover"
      trigger={
        <div className={props.isFirst ? 'first-child' : ''}>
          <LinkWrapper url={`/networks/${props.network}/users/${props.user.id}/about`}>
            <ProfileImage {...props} className={className} />
          </LinkWrapper>
        </div>
      }
      flowing
      hoverable
      mouseEnterDelay={500}
      mouseLeaveDelay={500}
      position="left center"
    >
      <PopoverContent {...props} />
    </Popup>
  );
}

const mapStateToProps = (state: any, props: any) => ({
  user: usersSelector.byId(state, props.user.id) || props.user,
  network: state.network.selected,
  loggedUserId: state.loggedUser.user.id,
});
const ConnectedMemberProfileImage = withRouter(
  connect(mapStateToProps)(MemberProfileImage),
);

function FullListColleague(props: any) {
  return (
    <Profile
      enablePopover
      {...props}
      fullComponentWrapper={
    (children:ReactNode) => (
      <LinkWrapper
        className="tw-text-inherit hover:tw-text-inherit hover:tw-underline Profile tw-block"
        url={`/networks/${props.network}/users/${props.user.id}/about`}
      >
        {children}
      </LinkWrapper>
    )
    }
    />
  );
}

const ConnectedFullListColleague = withRouter(
  connect(mapStateToProps)(FullListColleague),
);

export const MembersWidget = connector(({ channel, fetchMembers, onEnter }: Props) => {
  const { t } = useTranslation();

  const filter = R.pick(['type', 'id'], channel);

  // Because we already show network members for feed, no need to fetch them again
  // @ts-expect-error
  if (channel.type === ETimelineTypes.FEED) filter.type = ETimelineTypes.NETWORK;

  return (
    <div className="balloon">
      <AsyncList
        data={{
          filter,
          // @ts-expect-error
          onFetch: fetchMembers,
          limit: 10,
        }}
        containerClassName="Members"
        // @ts-expect-error
        renderRow={ConnectedMemberProfileImage}
        rowProps={getRowProps}
        ShowMoreComponent={null} // Don't render show more component
        // @ts-expect-error
        header={({ pagination }) => (
          <h5 className="balloon__title">
            <span>
              {/* @ts-expect-error */}
              {(channel.type === ETimelineTypes.FEED || channel.type === ETimelineTypes.NETWORK)
                ? t('social:members_title_colleagues')
                : t('social:members_title_members')}
              {pagination.total_count > 0 && <small>{pagination.total_count}</small>}
            </span>
            <div className="pull-right">
              <Modal
                title={(
                  // @ts-expect-error
                  (channel.type === ETimelineTypes.FEED || channel.type === ETimelineTypes.NETWORK)
                    ? t('social:members_title_colleagues')
                    : t('social:members_title_members')
                )}
                onEnter={onEnter}
                content={(
                  <AsyncList
                    data={{
                      filter,
                      // @ts-expect-error
                      onFetch: fetchMembers,
                    }}
                    // @ts-expect-error
                    renderRow={ConnectedFullListColleague}
                    rowProps={getRowProps}
                  />
                )}
              >
                <a><Trans i18nKey="social:members_show_all" /></a>
              </Modal>
            </div>
          </h5>
        )}
        placeholder={(
          <Trans i18nKey="social:members_placeholder" />
        )}
      />
    </div>
  );
});
